var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--estimate-graph",style:({
	marginTop: _vm.convertErrorToHeight(_vm.maxError) + 15 + 'px',
	marginBottom: _vm.convertErrorToHeight(_vm.negativeMaxError) + 15 +'px'
})},_vm._l((_vm.estimateHistory),function(est){return _c('div',{key:est.id,staticClass:"error",class:[
			{larger: est.error>0}, 
			{smaller: est.error<0}, 
			{equal: est.error===0} ],style:({
			height: _vm.convertErrorToHeight(est.error) + 'px',
			top: est.error>0 ? '-'+_vm.convertErrorToHeight(est.error) + 'px' : ( est.error === 0 ? -5+'px' : 0 )
		})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }